<script>
    export let alignment = "normal";
    export let justify = "flex-start";
    export let margin = "0";
    export let grow = false;
</script>

<div class:grow style="align-items: {alignment}; justify-content: {justify}; margin: {margin};">
    <slot />
</div>

<style>
    div {
        display: flex;
        flex-direction: column;
    }

    div.grow {
        /* width: 100%; */
        flex-grow: 1;
        align-items: stretch;
    }

    div > :global(*) {
        flex: 0 0 auto;
    }
</style>
